<template>
    <nav class="c-nav">
        <div class="c-nav__header">
            <h3 class="c-nav__title">Account</h3>
        </div>

        <ul class="c-nav__list">
            <li class="c-nav__item">
                <router-link class="c-nav__link" active-class="c-nav__link--current" exact-active-class="c-nav__link--current" to="/admin/locations">
                    <svg class="c-nav__link-svg" xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17">
                        <path d="M8 17v-6h4v6h5V9h3L10 0 0 9h3v8z" fill="#5c448d"/>
                    </svg>

                    Vestigingen
                </router-link>
            </li>
            <li class="c-nav__item">
                <router-link class="c-nav__link" active-class="c-nav__link--current" exact-active-class="c-nav__link--current" to="/admin/subscriptions">
                    <svg class="c-nav__link-svg" xmlns="http://www.w3.org/2000/svg" width="22" height="17.98" viewBox="0 0 22 17.98">
                        <path d="M18 4h-8v6h8zm2-4H2a2.006 2.006 0 00-2 2v14a1.989 1.989 0 002 1.98h18A1.989 1.989 0 0022 16V2a2.006 2.006 0 00-2-2zm0 16.01H2V1.98h18z" fill="#5c448d"/>
                    </svg>

                    Abonnementen
                </router-link>
            </li>
            <!--<li class="c-nav__item">
                <router-link class="c-nav__link" active-class="c-nav__link&#45;&#45;current" exact-active-class="c-nav__link&#45;&#45;current" to="/admin/licenses">
                    <svg class="c-nav__link-svg" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                        <path d="M18 0H2a1.993 1.993 0 00-2 2v11a1.993 1.993 0 002 2h4v5l4-2 4 2v-5h4a1.993 1.993 0 002-2V2a1.993 1.993 0 00-2-2zm0 13H2v-2h16zm0-5H2V2h16z" fill="#5c448d"/>
                    </svg>

                    Licenties
                </router-link>
            </li>-->
            <li class="c-nav__item">
                <router-link class="c-nav__link" active-class="c-nav__link--current" exact-active-class="c-nav__link--current" to="/admin/storec-mobiel">
                    <svg class="c-nav__link-svg" xmlns="http://www.w3.org/2000/svg" width="14.98" height="22" viewBox="0 0 14.98 22">
                        <g fill="#5c448d">
                            <path d="M14.98 20V2a2.006 2.006 0 00-2-2h-11A1.989 1.989 0 000 2v18a1.989 1.989 0 001.98 2h11a2.006 2.006 0 002-2zM1.97 20V2H13v18z"/>
                            <circle cx="1.5" cy="1.5" r="1.5" transform="translate(6 16.01)"/>
                        </g>
                    </svg>

                    Storec gebruikers
                </router-link>
            </li>
            <li class="c-nav__item">
                <router-link class="c-nav__link" active-class="c-nav__link--current" exact-active-class="c-nav__link--current" to="/admin/invoices">
                    <svg class="c-nav__link-svg" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                        <path d="M2 4H0v14a2.006 2.006 0 002 2h14v-2H2zm16-4H6a2.006 2.006 0 00-2 2v12a2.006 2.006 0 002 2h12a2.006 2.006 0 002-2V2a2.006 2.006 0 00-2-2zm-1 9H7V7h10zm-4 4H7v-2h6zm4-8H7V3h10z" fill="#5c448d"/>
                    </svg>

                    Facturen
                </router-link>
            </li>
            <!--<li class="c-nav__item">
                <router-link class="c-nav__link" active-class="c-nav__link&#45;&#45;current" exact-active-class="c-nav__link&#45;&#45;current" to="/admin/agreements">
                    <svg class="c-nav__link-svg" xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20">
                        <path d="M16 2h-4.18a2.988 2.988 0 00-5.64 0H2a2.006 2.006 0 00-2 2v14a2.006 2.006 0 002 2h14a2.006 2.006 0 002-2V4a2.006 2.006 0 00-2-2zM9 2a1 1 0 11-1 1 1 1 0 011-1zm2 14H4v-2h7zm3-4H4v-2h10zm0-4H4V6h10z" fill="#5c448d"/>
                    </svg>

                    Overeenkomsten
                </router-link>
            </li>-->
            <li class="c-nav__item">
                <router-link class="c-nav__link" active-class="c-nav__link--current" exact-active-class="c-nav__link--current" to="/admin/account">
                    <svg class="c-nav__link-svg" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                        <path d="M7 9.75A1.25 1.25 0 108.25 11 1.25 1.25 0 007 9.75zm6 0A1.25 1.25 0 1014.25 11 1.25 1.25 0 0013 9.75zM10 0a10 10 0 1010 10A10 10 0 0010 0zm0 18a8.011 8.011 0 01-8-8 8.108 8.108 0 01.05-.86 10.062 10.062 0 005.21-5.37A9.974 9.974 0 0015.42 8a9.76 9.76 0 002.25-.26A7.988 7.988 0 0110 18z" fill="#5c448d"/>
                    </svg>

                    Mijn gegevens
                </router-link>
            </li>
        </ul>
    </nav>
</template>

<script>
    export default {

    };
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/_essentials.scss";

    .c-nav {
        @include fixed(left 0 bottom 0);
        @include set-properties;
        background-color: $white;
        overflow-y: auto;
        width: rem($sidebar-width);

        @include media-breakpoint-down(md) {
            display: none;
        }

        /*@include media-breakpoint-only(lg) {
            width: rem(250);
        }*/

        &__header {
            align-items: center;
            height: grid(3, lg);
            padding-left: grid(2, lg);
            display: flex;
        }

        &__title {
            margin-bottom: 0;
        }

        &__list {
            @include zero;
            list-style: none;
        }

        &__item {
            & + & {

            }
        }

        &__link {
            align-items: center;
            border-top: rem(1) solid $border-color;
            color: $brand-danger;
            display: flex;
            font-size: rem(18);
            font-weight: $font-weight-bold;
            height: grid(2, lg);
            padding: 0 grid(1, lg) 0 grid(2, lg);
            transition: $transition-base;

            @include hover-focus {
                color: $brand-primary;
            }

            &--current {
                background-color: $border-color;
                color: $brand-primary;
            }

            &-svg {
                margin-right: grid(1, sm);
            }
        }
    }
</style>
